import { Component, OnInit, Inject } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

declare var $: any;

@Component({
  selector: 'app-confirm-create',
  templateUrl: './confirm-create.component.html',
  styleUrls: ['./confirm-create.component.css']
})
export class ConfirmCreateComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      $('#overlay').show();
    }

  hideOverlay(): void {
    $('#overlay').hide();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/partials/confirm-create/confirm-create.component.ts